import _ from 'lodash';
import * as fb from '../firebase';

import mealsServices from './meals.service';

export default {
  getRef(plannedMealId) {
    return fb.plannedMealsCollection.doc(plannedMealId);
  },

  /**
   * Récupère un plannedMeal
   * @param {Number} plannedMealId
   */
  getPlannedMeal(plannedMealId) {
    return this.getRef(plannedMealId)
      .get()
      .then((plannedMeal) => {
        if (plannedMeal.exists) {
          return {
            id: plannedMealId,
            ...plannedMeal.data(),
          };
        }
        return {};
      });
  },

  /**
   * Ajout d'un plannedMeal
   * @param {Object} plannedMeal
   */
  addPlannedMeal(plannedMeal) {
    // On ajoute le meal
    fb.plannedMealsCollection.add(plannedMeal).then(() => {
      // PUIS on fait les modifs
      const mealId = _.get(plannedMeal, 'meal.id', null);
      if (mealId) {
        // On incrémente le meal counter
        mealsServices.incrementCounter(mealId);
        // On MAJ le last used
        mealsServices.setAutoLastUsed(mealId, plannedMeal.date);
      }
    });
  },
  removePlannedMeal(plannedMealId) {
    // On récupère d'abord le plannedMeal
    this.getRef(plannedMealId)
      .get()
      .then((plannedMeal) => {
        if (plannedMeal.exists) {
          // then delete planned meal
          plannedMeal.ref.delete().then(() => {
            // PUIS on fait les modifs
            // decrement meal counter
            const mealId = _.get(plannedMeal.data(), 'meal.id', null);
            if (mealId) {
              mealsServices.decrementCounter(mealId);
              // Maj le last used en récupérant le dernier plannedMeal
              mealsServices.setAutoLastUsed(mealId);
            }
          });
        }
      });
  },
  updatePlannedMeal(plannedMealId, updatedPlannedMeal) {
    const newMealId = _.get(updatedPlannedMeal, 'meal.id', null);
    this.getRef(plannedMealId)
      .get()
      .then((plannedMeal) => {
        if (plannedMeal.exists) {
          // on modifie en base
          plannedMeal.ref.update(updatedPlannedMeal).then(() => {
            // PUIS on fait les modifs
            // On récupère l'ancien meal
            const oldMealId = _.get(plannedMeal.data(), 'meal.id', null);
            // On met à jour les last used
            if (oldMealId) {
              // Si default Meal, pas d'id
              mealsServices.setAutoLastUsed(oldMealId);
            }
            if (newMealId) {
              // Si default Meal, pas d'id
              mealsServices.setAutoLastUsed(newMealId);
            }

            if (oldMealId && newMealId && oldMealId !== newMealId) {
              // On a changé de meal, on change l'incrémentation des 2
              mealsServices.decrementCounter(oldMealId);
              mealsServices.incrementCounter(newMealId);
            }
          });
        }
      });
  },
};
